export default __webpack_public_path__ + "static/media/www.fc7feff3.svg";